import { LoadingSpaceType } from 'src/app/core/types';
import { Container, LoadingSpace, AirContainer, OtherLoadingSpace, Truck } from './loading-space';
import { CabinDimensionsGenerator } from 'src/app/core/utils/cabin-dimensions-generator';

export class LoadingSpaceFactory {
  public createLoadingSpace(
    loadingSpace: LoadingSpaceType,
    unit: string,
  ): LoadingSpace | Container | AirContainer | Truck | OtherLoadingSpace {
    if (loadingSpace.type === 1) {
      return new Truck(
        loadingSpace.name,
        loadingSpace.length,
        loadingSpace.width,
        loadingSpace.height,
        loadingSpace.limit,
        loadingSpace.length1,
        loadingSpace.width1,
        loadingSpace.height1,
        loadingSpace.limit1,
        loadingSpace.set,
        loadingSpace.type,
        loadingSpace.axis,
        CabinDimensionsGenerator(unit, loadingSpace),
        loadingSpace.varioTrailerFloorHeight,
        loadingSpace.varioSemiTrailerFloorHeight,
        loadingSpace.varioTrailerFloorThickness,
        loadingSpace.varioSemiTrailerFloorThickness,
        loadingSpace.varioTrailerFloorCapacity,
        loadingSpace.varioSemiTrailerFloorCapacity,
        loadingSpace.coolerTrailerWidth,
        loadingSpace.coolerTrailerHeight,
        loadingSpace.coolerTrailerLength,
        loadingSpace.coolerTrailerFloorHeight,
        loadingSpace.coolerSemiTrailerWidth,
        loadingSpace.coolerSemiTrailerHeight,
        loadingSpace.coolerSemiTrailerLength,
        loadingSpace.coolerSemiTrailerFloorHeight,
        loadingSpace.wheelTrailerWidth,
        loadingSpace.wheelTrailerHeight,
        loadingSpace.wheelTrailerLength,
        loadingSpace.wheelTrailerDistance,
        loadingSpace.wheelSemiTrailerWidth,
        loadingSpace.wheelSemiTrailerHeight,
        loadingSpace.wheelSemiTrailerLength,
        loadingSpace.wheelSemiTrailerDistance,
        unit,
        loadingSpace.airType,
        loadingSpace.airLengthA,
        loadingSpace.airWidth,
        loadingSpace.airBaseB,
        loadingSpace.airHeightC,
        loadingSpace.airHeightD,
        null,
        loadingSpace.trailerLoadingSide,
        loadingSpace.semiTrailerLoadingSide,
        null,
        null,
        null,
        null,
        null,
        loadingSpace.view,
        null,
        null,
        loadingSpace.gravityShowCenter,
        loadingSpace.gravitySemiTrailerLengthTolerance,
        loadingSpace.gravitySemiTrailerWidthTolerance,
        loadingSpace.gravityTrailerLengthTolerance,
        loadingSpace.gravityTrailerWidthTolerance,
        loadingSpace.trailerContainerWeight,
        loadingSpace.semiTrailerContainerWeight,
        loadingSpace.trailerCOGX,
        loadingSpace.trailerCOGY,
        loadingSpace.trailerCOGZ,
        loadingSpace.semiTrailerCOGX,
        loadingSpace.semiTrailerCOGY,
        loadingSpace.semiTrailerCOGZ,
      );
    } else if (loadingSpace.type === 2) {
      return new Container(
        loadingSpace.name,
        loadingSpace.length,
        loadingSpace.width,
        loadingSpace.height,
        loadingSpace.limit,
        loadingSpace.length1,
        loadingSpace.width1,
        loadingSpace.height1,
        loadingSpace.limit1,
        loadingSpace.set,
        loadingSpace.type,
        loadingSpace.axis,
        CabinDimensionsGenerator(unit, loadingSpace),
        null,
        null,
        null,
        null,
        null,
        null,
        loadingSpace.coolerTrailerWidth,
        loadingSpace.coolerTrailerHeight,
        loadingSpace.coolerTrailerLength,
        loadingSpace.coolerTrailerFloorHeight,
        loadingSpace.coolerSemiTrailerWidth,
        loadingSpace.coolerSemiTrailerHeight,
        loadingSpace.coolerSemiTrailerLength,
        loadingSpace.coolerSemiTrailerFloorHeight,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        unit,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        loadingSpace.trailerLoadingSide,
        loadingSpace.semiTrailerLoadingSide,
        null,
        loadingSpace.trailerDoorWidth,
        loadingSpace.trailerDoorHeight,
        loadingSpace.semiTrailerDoorWidth,
        loadingSpace.semiTrailerDoorHeight,
        loadingSpace.view,
        null,
        null,
        loadingSpace.gravityShowCenter,
        loadingSpace.gravitySemiTrailerLengthTolerance,
        loadingSpace.gravitySemiTrailerWidthTolerance,
        loadingSpace.gravityTrailerLengthTolerance,
        loadingSpace.gravityTrailerWidthTolerance,
        loadingSpace.trailerContainerWeight,
        loadingSpace.semiTrailerContainerWeight,
        loadingSpace.trailerCOGX,
        loadingSpace.trailerCOGY,
        loadingSpace.trailerCOGZ,
        loadingSpace.semiTrailerCOGX,
        loadingSpace.semiTrailerCOGY,
        loadingSpace.semiTrailerCOGZ,
      );
    } else if (loadingSpace.type === 4) {
      return new AirContainer(
        loadingSpace.name,
        loadingSpace.length,
        loadingSpace.width,
        loadingSpace.height,
        loadingSpace.limit,
        loadingSpace.length1,
        loadingSpace.width1,
        loadingSpace.height1,
        loadingSpace.limit1,
        loadingSpace.set,
        loadingSpace.type,
        loadingSpace.axis,
        CabinDimensionsGenerator(unit, loadingSpace),
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        unit,
        loadingSpace.airType,
        loadingSpace.airLengthA,
        loadingSpace.airWidth,
        loadingSpace.airBaseB,
        loadingSpace.airHeightC,
        loadingSpace.airHeightD,
        null,
        loadingSpace.trailerLoadingSide,
        loadingSpace.semiTrailerLoadingSide,
        null,
        null,
        null,
        null,
        null,
        loadingSpace.view,
        null,
        null,
        loadingSpace.gravityShowCenter,
        loadingSpace.gravitySemiTrailerLengthTolerance,
        loadingSpace.gravitySemiTrailerWidthTolerance,
        loadingSpace.gravityTrailerLengthTolerance,
        loadingSpace.gravityTrailerWidthTolerance,
        loadingSpace.trailerContainerWeight,
        loadingSpace.semiTrailerContainerWeight,
        loadingSpace.trailerCOGX,
        loadingSpace.trailerCOGY,
        loadingSpace.trailerCOGZ,
        loadingSpace.semiTrailerCOGX,
        loadingSpace.semiTrailerCOGY,
        loadingSpace.semiTrailerCOGZ,
      );
    } else {
      return new OtherLoadingSpace(
        loadingSpace.name,
        loadingSpace.length,
        loadingSpace.width,
        loadingSpace.height,
        loadingSpace.limit,
        loadingSpace.length1,
        loadingSpace.width1,
        loadingSpace.height1,
        loadingSpace.limit1,
        loadingSpace.set,
        loadingSpace.type,
        loadingSpace.axis,
        CabinDimensionsGenerator(unit, loadingSpace),
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        loadingSpace.palletMaxHeight,
        loadingSpace.palletHeight,
      );
    }
  }
}
